<template>
  <b-modal :id="idModal" class="modal-info" hide-footer size="xl" scrollable centered @hide="handleOfModal">
    <template v-slot:modal-header>
      <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
        <h4 class="modal-info__title font-sanpro-light secondary-color-txt font-size-18" v-if="infoQuestionPreview && infoQuestionPreview.category">
          <span v-if="infoQuestionPreview.category.grand" class="exercise-cat__grand">
            <span v-if="infoQuestionPreview.category.grand.title">{{ infoQuestionPreview.category.grand.title }}: </span>
            <span>{{ infoQuestionPreview.category.grand.name }} </span>
            <span class="exercise-cat__icon"><i class="icon-next1 secondary-color-txt"></i></span>
          </span>
          <span v-if="infoQuestionPreview.category.parent" class="exercise-cat__parent">
            <span v-if="infoQuestionPreview.category.parent.title">{{ infoQuestionPreview.category.parent.title }} </span>
            <span>{{ infoQuestionPreview.category.parent.name }}: </span>
            <span class="exercise-cat__icon"><i class="icon-next1 secondary-color-txt"></i></span>
          </span>
          <span class="exercise-cat__child">
            <span v-if="infoQuestionPreview.category.title">{{ infoQuestionPreview.category.title }}: </span>
            <span>{{ infoQuestionPreview.category.name }} </span>
          </span>
        </h4>

        <span @click="$bvModal.hide(idModal)" class="modal-info__close"><i class="icon-close"></i></span>
      </div>
    </template>
    <div class="modal-info__body">
      <ExerciseQuestionList :dataSource="infoQuestionPreview.questions" />
    </div>
  </b-modal>
</template>

<script>
  import { ID_MODAL_PREVIEW_EXERCISE, STORE_KEY } from './../../_store/constants'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'ModalPreviewExercise',
    components: {
      ExerciseQuestionList: () => import('./../ExerciseQuestionList.vue'),
    },
    computed: {
      ...mapState(STORE_KEY, ['infoQuestionPreview'])
    },
    data () {
      return {
        idModal: ID_MODAL_PREVIEW_EXERCISE
      }
    },
    methods: {
      ...mapActions(STORE_KEY, ['acSetQuestionPreviewInfo']),

      handleOfModal () {
        this.acSetQuestionPreviewInfo({})
      }
    }
  }
</script>

<style lang="scss">
.modal-body {
  background: $color_light!important;
}
</style>
<style lang="scss" scoped="">
.exercise-cat__icon {
  margin: 0 10px;
}
</style>